import React, { useContext, useRef } from 'react';

import componentUtil from 'utils/component';
import _get from 'lodash/get';

import { LoaderContext } from 'components/theme/loader';

export default function withGraphQlLoaderHOC(
  Component,
  graphqlQueries,
  options = {}
) {
  const getError = (props) => {
    let error = false;
    graphqlQueries.some((q) => {
      error = _get(props, `${q.name}.error`, false);
      return error;
    });

    return error;
  };

  const getLoading = (props) => {
    return graphqlQueries.some((q) => {
      const isLoading = _get(props, `${q.name}.loading`, false);
      return isLoading;
    });
  };

  const getData = (props) => {
    const data = {};

    graphqlQueries.forEach((q) => {
      const dataTarget = q.data ? `.${q.data}` : '';
      data[q.name] = _get(props, `${q.name}${dataTarget}`);
    });

    return data;
  };

  const WithGraphQlLoader = (props) => {
    const { showLoader, hideLoader } = useContext(LoaderContext);
    const loaderRef = useRef();

    const {
      showLoader: showLoaderComp = true,
      hideLoader: hideLoaderComp = true,
      showSelfOnLoading = false,
      showSelfOnError = false,
      ...rest
    } = options;

    // Show Loading State
    const isLoading = getLoading(props);

    if (isLoading) {
      // Show Loader
      if (showLoaderComp && !loaderRef.current) {
        loaderRef.current = showLoader(rest);
      }
      // Return null if not showing self during loading
      if (!showSelfOnLoading) {
        return null;
      }
    } else if (hideLoaderComp && loaderRef.current) {
      // Hide loader
      hideLoader(loaderRef.current);
    }

    // error State
    const isError = getError(props);
    if (isError) {
      console.warn(isError);
      // Show Error : error will be catched and handled by error-link
      // Return null if not showing self during error
      if (!showSelfOnError) {
        return null;
      }
    }

    const data = getData(props);

    return (
      <Component {...props} data={data} loaderQueueId={loaderRef.current} />
    );
  };

  WithGraphQlLoader.displayName = componentUtil.getDisplayName(
    Component,
    'WithGraphQlLoader'
  );

  return WithGraphQlLoader;
}
